import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Input,
} from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import {
  ChangeLogsType,
  ConferenceKeys,
  LookupKeys,
  SELECTED_EXCURSIONS_KEYS_CONFIG,
  SelectedExcursionsKeys,
} from '@ag-common-lib/public-api';
import { UntilDestroy } from '@ngneat/until-destroy';
import { getDateTimeLog, logHasKey } from '../../utils/normalize-log';
import { ChangesHistoryGridService } from '../../changes-history-grid.service';
import { ChairmanExtensionConfigurationKeys } from '@ag-common-lib/lib/models/registration/conference-chairman-extension';
import { Conference } from '@ag-common-lib/lib/models/registration/conference.model';
import { ExcursionKeys } from '@ag-common-lib/lib/models/registration/excursion.model';

@UntilDestroy()
@Component({
  selector: 'ag-shr-excursions-change-log',
  templateUrl: './attendee-excursions-log-details.component.html',
  styleUrls: ['./attendee-excursions-log-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttendeeExcursionsLogDetailsComponent {
  isChairmanExt = input<boolean>(false);
  conference = input<Conference>(null);

  @Input()
  set changeLogs(delta: Delta) {
    if (!delta) {
      this._changeLogs = delta;
      return;
    }
    // added - Array[null, {sdf: {data: {...}}}], updated - {sdf: {data: [old, new]}}
    const selectedExcursions = Array.isArray(delta) ? delta[1] : delta;
    const logs = {};
    Object.entries(selectedExcursions).forEach(data => {
      const key = data[0];
      const value = data[1];
      this.excursionKeysIndexes.push(key);
      const selectedExcursionKeys = this.selectedExcursionsKeysConfig.map(({ value }) => value);
      selectedExcursionKeys.forEach(ind => {
        const excursionInd = ind.split('.')[1];
        const logValue = value[excursionInd];
        if (!logValue) {
          return;
        }
        if (excursionInd === SelectedExcursionsKeys.bookingDate) {
          Object.assign(value, { [SelectedExcursionsKeys.bookingDate]: getDateTimeLog(value) });
          return;
        }
        Object.assign(value, { [ind]: Array.isArray(logValue) ? logValue : [logValue] });
      });

      Object.assign(logs, { [key]: value });
    });
    this._changeLogs = logs;
  }
  get changeLogs(): Delta {
    return this._changeLogs;
  }
  @Input() attendeeName: string;
  @Input() caption: string = 'Excursions';

  readonly excursionsNameLookupSig = computed(() => {
    const isChairmanExt = this.isChairmanExt();
    const conference = this.conference();
    console.log('conference', conference);

    if (!conference) {
      return [];
    }

    const excursions = isChairmanExt
      ? (conference[ConferenceKeys.chairmanExtensionConfiguration]?.[ChairmanExtensionConfigurationKeys.excursions] ?? [])
      : (conference[ConferenceKeys.excursions] ?? []);

    if (!Array.isArray(excursions) || excursions.length === 0) {
      return [];
    }

    return excursions
      .filter(excursion => excursion?.[ExcursionKeys.id] && excursion?.[ExcursionKeys.name])
      .map(excursion => ({
        [LookupKeys.value]: excursion[ExcursionKeys.id],
        [LookupKeys.description]: excursion[ExcursionKeys.name],
      }));
  });

  protected readonly selectedExcursionsKeysConfig = SELECTED_EXCURSIONS_KEYS_CONFIG;
  protected readonly ChangeLogsType = ChangeLogsType;
  private _changeLogs: Delta;
  protected readonly logHasKey = logHasKey;
  protected readonly SelectedExcursionsKeys = SelectedExcursionsKeys;
  excursionKeysIndexes: string[] = [];

  constructor(changesHistoryGridService: ChangesHistoryGridService) {}
}
